import { useTranslation } from 'react-i18next'
import { X } from 'lucide-react'

interface AddToProductHeaderProps {
  title: string
  subtitle?: string
  onClose: () => void
  titleId?: string
}

export function AddToProductHeader({ title, subtitle, onClose, titleId }: AddToProductHeaderProps) {
  const { t } = useTranslation()
  return (
    <header className="bg-white dark:bg-neutral-900 border-b border-neutral-200 dark:border-neutral-800 px-6 py-3 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-primary-500 to-primary-400 flex items-center justify-center text-white text-sm font-bold">
          +
        </div>
        <div>
          <div id={titleId} className="text-base font-semibold text-neutral-900 dark:text-neutral-100">
            {title}
          </div>
          {subtitle && (
            <div className="text-xs text-neutral-500 dark:text-neutral-400">{subtitle}</div>
          )}
        </div>
      </div>
      <button
        type="button"
        onClick={onClose}
        aria-label={t('addToProduct.headerClose')}
        className="flex items-center gap-2 px-3 py-1.5 text-sm text-neutral-600 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded-lg"
      >
        <span>{t('addToProduct.headerClose')}</span>
        <X className="w-4 h-4" />
      </button>
    </header>
  )
}
